/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEnhancedTranslation } from '@app/hooks';
import cx from 'classnames';
import { Field, FieldProps } from 'formik';
import { FC } from 'react';
// import { Trans } from 'react-i18next';
// import cx from 'classnames';
import RadioButton from '@app/components/radio-button/radio-button';
import './gender-radio-group.scss';

type AgreementProps = {
  className?: string;
  textKey?: string;
  name: string;
};

export const GenderRadioGroup: FC<AgreementProps> = ({ textKey = 'common.form.gender', name, className }) => {
  const { t } = useEnhancedTranslation({ keyPrefix: textKey });

  return (
    <div className="gender-radio-group">
      <Field name={name}>
        {({ field, form }: FieldProps) => (
          <label className={cx(className, 'field-label')} htmlFor={name}>
            <div className="gender-radio-label">{t('groupCaption')}</div>
            <div className="gender-radio-group-item">
              <RadioButton
                name="gender"
                title={t('groupValue.male') || ''}
                value="M"
                radioValue={field.value}
                onChange={(v) => form.setFieldValue(name, v)}
              />
              <RadioButton
                name="gender"
                title={t('groupValue.female') || ''}
                value="F"
                radioValue={field.value}
                onChange={(v) => form.setFieldValue(name, v)}
              />
              <RadioButton
                name="gender"
                title={t('groupValue.unknown') || ''}
                value={null}
                radioValue={field.value}
                onChange={(v) => form.setFieldValue(name, v)}
              />
            </div>
          </label>
        )}
      </Field>
    </div>
  );
};
